/* eslint-disable @typescript-eslint/no-magic-numbers */
import { useQuery } from '@tanstack/react-query';
import Constants from 'Constants';
import { makeRequest } from 'services/api';
import { createKey } from 'utils/helper';

const useServerTime = () => {
  return useQuery({
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    retryOnMount: true,
    refetchInterval: 50 * 1000,
    queryKey: createKey(Constants.GET_SERVER_TIME_URL, {}),
    queryFn: async () => {
      const result = await makeRequest<{ serverTime: string }>(
        Constants.GET_SERVER_TIME_URL,
        {},
        {},
      );
      return result;
    },
    enabled: !!localStorage.getItem('accessToken'),
    select: (data) => {
      /*
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment
      const serverTime = data.headers['date'];
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      if (onSuccess) onSuccess(serverTime);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      */
      return data.data;
    },
  });
};

export default useServerTime;
